import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, withModifiers as _withModifiers, resolveDirective as _resolveDirective, openBlock as _openBlock, createBlock as _createBlock, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/logo-2.jpg'


const _withScopeId = n => (_pushScopeId("data-v-49a153ce"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "logo-wrapper" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    alt: "logo"
  })
], -1))
const _hoisted_2 = { class: "text-center" }

import { reactive, ref } from 'vue'
import store from '@/store'
import { ElNotification, FormInstance, FormRules } from 'element-plus'
import useFormRequest from '@/composables/useFormRequest'
import { iLoginForm } from '@/types/common/requests'
import { login } from '@/store/actions/auth'
import VueTurnstile from 'vue-turnstile'


export default /*#__PURE__*/_defineComponent({
  __name: 'LoginForm',
  setup(__props) {

const formRef = ref<FormInstance>()

const formRequest = useFormRequest<iLoginForm>()

const turnstileSiteKey = process.env.VUE_APP_CLOUDFLARE_SITE_KEY

const form = reactive<iLoginForm>({
  email: '',
  password: '',
  captcha: ''
})

const rules = reactive<FormRules<iLoginForm>>({
  email: [
    { required: true, message: 'Введите email', trigger: 'blur' }
  ],
  password: [
    { required: true, message: 'Введите пароль', trigger: 'blur' }
  ]
})

const handleSubmit = async () => {
  await formRef.value?.validate((valid: boolean) => {
    if (valid) {
      formRequest.tryRequest(async () => {
        store.login(await login(form))
        ElNotification({ message: 'Вы успешно авторизовались', type: 'success' })
      })
    }
  })
}


return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_card = _resolveComponent("el-card")!
  const _component_el_main = _resolveComponent("el-main")!
  const _component_el_container = _resolveComponent("el-container")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createBlock(_component_el_container, null, {
    default: _withCtx(() => [
      _createVNode(_component_el_main, null, {
        default: _withCtx(() => [
          _hoisted_1,
          _createVNode(_component_el_card, { class: "login-card" }, {
            header: _withCtx(() => [
              _createTextVNode("Авторизация")
            ]),
            default: _withCtx(() => [
              _withDirectives((_openBlock(), _createBlock(_component_el_form, {
                model: form,
                rules: rules,
                ref_key: "formRef",
                ref: formRef,
                "status-icon": "",
                onSubmit: _withModifiers(handleSubmit, ["prevent"])
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_form_item, {
                    prop: "email",
                    error: _unref(formRequest).state.errors.email
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        modelValue: form.email,
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((form.email) = $event)),
                        placeholder: "E-mail",
                        type: "text",
                        autocomplete: "email"
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }, 8, ["error"]),
                  _createVNode(_component_el_form_item, {
                    prop: "password",
                    error: _unref(formRequest).state.errors.password
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        modelValue: form.password,
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((form.password) = $event)),
                        placeholder: "Пароль",
                        type: "password",
                        autocomplete: "password"
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }, 8, ["error"]),
                  _createVNode(_component_el_form_item, {
                    prop: "captcha",
                    error: _unref(formRequest).state.errors.captcha,
                    class: "captcha-wrapper"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(VueTurnstile), {
                        modelValue: form.captcha,
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((form.captcha) = $event)),
                        "site-key": _unref(turnstileSiteKey),
                        theme: "light",
                        size: "flexible"
                      }, null, 8, ["modelValue", "site-key"])
                    ]),
                    _: 1
                  }, 8, ["error"]),
                  _createVNode(_component_el_form_item, null, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_2, [
                        _createVNode(_component_el_button, {
                          type: "primary",
                          "native-type": "submit"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("Войти")
                          ]),
                          _: 1
                        })
                      ])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["model", "rules"])), [
                [_directive_loading, _unref(formRequest).state.pending]
              ])
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})